import { getActiveCustomerForDataverse } from './dataverse';
import { getCustomerUnlocProjectId } from './customers';

const DEFAULT_UNLOC_APIM_URL = 'https://opencareapi.azure-api.net/Unloc';

export function getUnlocApimBaseUrl() {
  const fromEnv = process.env.REACT_APP_UNLOC_APIM_URL;
  return (fromEnv || DEFAULT_UNLOC_APIM_URL).replace(/\/$/, '');
}

export function getActiveUnlocProjectId() {
  const { customer } = getActiveCustomerForDataverse();
  return getCustomerUnlocProjectId(customer);
}
